import apolloProvider from '@/vue-apollo';
const apolloClient = apolloProvider.defaultClient;

import { get } from '@/helpers';

import PageGql from '@/store/graphql/queries/Page.gql';
import PagesPaginatedGql from '@/store/graphql/queries/PagesPaginated.gql';

export default {
  fetchPagesPaginated: data =>
    new Promise((resolve, reject) => {
      let filters = [];
      data.filters.forEach(entry => filters.push(entry));

      apolloClient
        .query({
          query: PagesPaginatedGql,
          variables: {
            currentPage: get(data, 'pageInfo.currentPage', 1),
            perPage: get(data, 'pageInfo.perPage', 25),
            order: get(data, 'variables.order', 'publish_start'),
            direction: get(data, 'variables.direction', 'desc'),
            filters
          }
        })
        .then(({ data }) => resolve(data.CP_PagesPaginated))
        .catch(err => reject(err));
    }),
  fetchPage: variables => {
    return new Promise((resolve, reject) => {
      apolloClient
        .query({ query: PageGql, variables })
        .then(({ data }) => resolve(data.CP_Page))
        .catch(err => reject(err));
    });
  }
};
